<template>
    <router-link class="router-link" active-class="active-class" :to="`/${routingTo}`">
      <div class="menu-element">
      <v-icon
        medium
      >
        {{logoName}}
      </v-icon>
        {{content}}
      </div>
    </router-link>
</template>

<script>
export default {
  name: "MenuElement",
  props: {
    routingTo: {
      type: String,
      required: true
    },
    logoName: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    }
  },
}
</script>

<style >
.menu-element {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: black;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
}
.active-class {
  color: var(--secondary-color) !important;
  font-weight: bold;
}
.router-link {
  text-decoration: none;
  color: black !important;
  cursor: pointer;
}
</style>